<template>
  <div id="home">
    <div class="homeWrap">
      <div class="moduleWrap">
        <div class="moduleUp">
          <router-link class="linkA" to="/qualificationInquire/stu">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="user-cog" scale="4"></v-icon>
              </div>
              <p>教练员查询</p>
            </div>
          </router-link>
          <router-link class="linkA" to="/setting/person">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="user-cog" scale="4"></v-icon>
              </div>
              <p>个人设置</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEvaluated } from "@/api/training_student/api";
import { info_view, organList } from "@/api/ab_signup/api";
import { getStuHistoryTrian } from "@/api/system_manager/api";
import { storageData } from "@/assets/js/storage";
import { questionCheck } from "@/api/survey/index";
import "vue-awesome/icons/sitemap";
import "vue-awesome/icons/clipboard-list";
import "vue-awesome/icons/users-cog";
import "vue-awesome/icons/chalkboard-teacher";
import "vue-awesome/icons/user-cog";
import "vue-awesome/icons/regular/file-alt";
import "vue-awesome/icons/check";
import "vue-awesome/icons/file-signature";
import "vue-awesome/icons/comment-alt"; // 提示气泡
import "vue-awesome/icons";
import fiveMixins from "@/minix/fiveMixins";

export default {
  name: "studentIndex",
  mixins: [fiveMixins],
  data() {
    return {
      allDisabled: false,
      showUploadQua: true,
      showHistory: false,
      showEnroll: false,
      showList: false,
      showTrainEnroll: false,
      showZhuanxiangEnroll: false,
      showSelectOrganDialog:false,
      advance_admission:"",
      advance_admission_name:"",
      advance_admission_show:false,
      enroll_choose_again_uuid:"",
      organList:[],
      achievement_verify: "",
      survey_id: "",
      isSurvey: 0,
      tips: {
        title: "",
        button_text: "",
        show_type: "",
      },
      showEnrollQingxun: false,
      isShowActionInfo: false,
    };
  },
  components: {
    "v-icon": () => import("vue-awesome/components/Icon"),
    "select-organ" :() => import('@/components/Tips/select-organ'),
    "enroll-dialog": () => import("@/views/Login/qingxunEnrollInfo"),
  },
  created() {
    const userInfo = storageData.getUserInfo();
    if (userInfo.class_level !== "D" && userInfo.class_level !== "early") {
      this.showHistory = true;
    }
    

  },
  methods: {
  
  
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
#home
  width 100%
  height 100%
  display flex
  justify-content center
  align-items center
  user-select none
  .homeWrap
    width 930px
    position: relative;
    .HTM_PRO{
      position: absolute;
      top: -1px;  /* 距离父元素顶部50像素 */
      right: 20px; /* 距离父元素左侧20像素 */
    }
    .logoTitle
      height 85px
      display flex
      flex-direction column
      justify-content center
      align-items center
      margin 0 0 40px 0
      color $color_title
      font-size 40px
      font-weight bolder
      text-shadow 2px 1px 3px #231815
    .moduleWrap
      .moduleUp
        margin 40px 0
        display flex
        .linkA
          flex 1 1 auto
          margin 0 20px
        .linkA_samll
          width 195px
        .linkA_big
          width 420px
      .moduleDown
        margin 40px 0
        display flex
        .linkA
          flex 1 1 auto
          margin 0 20px
        .linkA_samll
          width 430px
      .moduleItem
        position relative
        width 100%
        height 200px
        display flex
        flex-direction column
        justify-content center
        align-items center
        color $color_white
        font-size 23px
        background-color $block_bg_color_base
        cursor pointer
        .icon
          display flex
          align-items center
        p
          margin 20px 0 0
      .moduleItem-big
        position relative
        width 100%
        height 100%
        cursor default
        .item-wrapper-normal
          width 100%
          height 200px
          display flex
          flex-direction column
          justify-content center
          align-items center
          color $color_white
          font-size 23px
          background-color $block_bg_color_base
          cursor pointer
          .icon
            display flex
            align-items center
          p
            margin 20px 0 0
        .item-wrapper-hover
          width 100%
          height 100%
          display none
          .item-wrapper-hover-content
            height 100%
            width calc(50% - 15px)
            background-color $block_bg_color_base
            color $color_white
            display flex
            flex-direction column
            justify-content center
            align-items center
            color $color_white
            font-size 23px
            cursor pointer
            .icon
              display flex
              align-items center
            p
              margin 20px 0 0
      .moduleItem-big:hover .item-wrapper-normal
        display none
      .moduleItem-big:hover .item-wrapper-hover
        display flex
        justify-content space-between
        width 100%
        height 100%
      .classItem
        .tips
          position absolute
          top calc(20% - 15px)
          right calc(35% - 15px)
          .icon
            color $color_suc
          .num
            width 100%
            height 100%
            padding 2px 0 0
            position absolute
            top 0
            left 0
            text-align center
            font-size $font_size_big
  .to-eval
    font-size 16px
    text-align center
    img
      width 100px
    .tips
      margin-bottom 15px
</style>
<style lang="stylus" >
.el-badge__content.is-dot
  height 12px
  width 12px
  padding 0
  right 0
  border-radius 50%
</style>

